import {
  NameType,
  Payload,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";
import { COLORS } from "../components/recharts/ReCharts";
import { COLOR_CODES } from "../common";
import { LabelPosition } from "recharts/types/component/Label";

export interface ReChartData {
  [key: string]: number | string | Date | null | undefined;
}

export enum ChartType {
  Line,
  Bar,
  Area,
}

export interface LegendKey {
  name?: string;
  stroke?: string;
  unit?: string;
  dataKey: string;
  type?: ChartType;
  yAxisId?: string;
  legendColor?: string;
  stackId?: string;
  isDash?: boolean;
  dateKey?: string;
  [key: string]: any;
  // color: string;
}

export const BAR_RADIUS: number | [number, number, number, number] = [
  4, 4, 0, 0,
];

export function getColorList(length: number) {
  let colors = [];
  for (let i = 0; i < length; i++) {
    colors.push(Object.values(COLOR_CODES)[i % COLORS.length]);
  }
  return colors;
}

export enum BrushStart {
  Start,
  End,
}

interface BrushIndex {
  startIndex: number;
  endIndex: number;
}

export interface ChartArguements {
  data: ReChartData[];
  legends: LegendKey[];
  legendBreakIndex?: number;
  syncid?: string;
  overflowLegend?: boolean;
  unit?: string;
  labelFontSize?: number;
  xDataKey: string;
  circleLegend?: boolean;
  xTick?: any;
  maxYsize?: number;
  disableLegendClick?: boolean;
  legendFontSize?: number;
  barCategoryGap?: number;
  xLabel?: string;
  onlyTitle?: boolean;
  xAxisLabelPosition?: LabelPosition;
  disableLegend?: boolean;
  yAxisWidth?: number;
  xaxisHeight?: number;
  xAxisAngle?: number;
  secondXAxisHeight?: number;
  xAxisTickMargin?: number;
  secondXAxisLabel?: string;
  secondXDataKey?: string;
  secondYAxisWidth?: number;
  yAxisLabel?: string;
  fontSize?: number;
  isTimeSlot?: boolean;
  hidePrice?: boolean;
  showBrush?: boolean;
  xAxisLabelOffset?: number;
  brushHeight?: number;
  rendexSecondXTick?: any;
  onBarClick?: (payload: any) => void;
  onLegendSelect?: any;
  brushIndex?: BrushIndex;
  brushStart?: BrushStart;
  secondYAxisLabel?: string;
  showSecondYAxis?: boolean;
  customTooltip?: any;
  hiddenLegends?: string[];
  hiddenStats?: string[];
  dynamicMarginTop?: string;
  chartHeight?: string;
  enableMouseWheelZoom?: boolean;
  chartContainerHeight?: string;
  tooltip_key?: string;
  nameGap?: number; // Gap for axis names
  yMaxValue?: number; // Maximum value for Y axis
  tooltipFilter?: any;
  legendMaxHeight?: string;
  isPriceForecast?: boolean; // Flag to indicate if the chart is for price forecasting
  defaultSelectedLegends?: LegendKey[]; // Default selected legends for filtering
  showToolbox?: boolean; // Whether to show toolbox
  top?: number; // Top margin for grid
  bottom?: number; // Bottom margin for grid
  left?: number; // Left margin for grid
  yAxisDomain?: number[];
  secondYAxisDomain?: number[]; // Domain for the second Y axis
  isSmallLegend?: boolean;
  customLegendOrder?: string[]; // Custom order for legend items
}

export interface ChartRecord {
  total_volume_mwh: number;
  weighted_average_price: number;
  [key: string]: any;
}
